// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__22iSp","unreadBadge":"styles_unreadBadge__2XYkW","modalContent":"styles_modalContent__1vQVf","modal":"styles_modal__15pGQ"};